import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { productCategoryApi } from "../../api/api";

const KEY = "categories";

/** All categories (includes root parents) */
export function useCategories() {
  return useQuery({
    queryKey: [KEY],
    queryFn: productCategoryApi.getAll,
  });
}

/**
 * Leaf categories only — filters out root parents (parentCategoryID is null or 0).
 * Use this for every dropdown across the app.
 */
export function useLeafCategories() {
  const query = useCategories();
  return {
    ...query,
    data: query.data
      ? query.data.filter((c) => c.parentCategoryID && c.parentCategoryID !== 0)
      : [],
  };
}

export function useCategory(id) {
  return useQuery({
    queryKey: [KEY, id],
    queryFn: () => productCategoryApi.getById(id),
    enabled: !!id,
  });
}

export function useCreateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: productCategoryApi.create,
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}

export function useUpdateCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: productCategoryApi.update,
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}

export function useDeleteCategory() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: productCategoryApi.delete,
    onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
  });
}
